import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  samplerDetails: null,
  districts: [],
  states: [],
  agencies: [],  
  districtsOfMultipleStates: [],  
};

const samplerEditSlice = createSlice({
  name: "samplerEdit",
  initialState,
  reducers: {
    fetchSamplerDetails(state, action) {
      state.loading = true;
    },
    fetchSamplerDetailsSuccess(state, action) {
      state.samplerDetails = action.payload;
      state.loading = false;
    },
    fetchSamplerDetailsFailure(state, action) {
      state.loading = false;
    },
    editSampler(state, action) {
      state.loading = true;
    },
    editSamplerSuccess(state, action) {
      state.loading = false;
    },
    editSamplerFailure(state, action) {
      state.loading = false;
    },
    fetchDistricts(state, action) {
      state.loading = true;
    },
    fetchDistrictsSuccess(state, action) {
      state.districts = action.payload.data.districts;
      state.loading = false;
    },
    fetchDistrictsFailure(state, action) {
      state.loading = false;
    },
    fetchStates(state, action) {
      state.loading = true;
    },
    fetchStatesSuccess(state, action) {
      state.states = action.payload.data.document;
      state.loading = false;
    },
    fetchStatesFailure(state, action) {
      state.loading = false;
    },
    fetchAgencies(state, action) {
      state.loading = true;
    },
    fetchAgenciesSuccess(state, action) {
      state.agencies = action.payload.data.documents;
      state.loading = false;
    },
    fetchAgenciesFailure(state, action) {
      state.loading = false;
    },
    initializeState(state) {
      state.samplerDetails = null;
      state.districts = [];
      state.states = [];
      state.agencies = [];
      state.error = null;
      state.loading = false;
    },

    fetchDistrictsOfMultipleStates(state, action) {},
    fetchDistrictsOfMultipleStatesSuccess(state, action) {
      state.districtsOfMultipleStates = action.payload.data?.states
        ?.map((s) => s.districts)
        ?.flat();
    },
    fetchDistrictsOfMultipleStatesFailure(state, action) {
      state.districtsOfMultipleStates = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = samplerEditSlice;
